import { fromJS } from 'immutable';

import { ApiUrl4,UserToken,SenderId } from '../../../helper/HelperAuth'
import { GetWaProfileImage } from '../../constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (senderid) => async (dispatch, getState) => {
    const Authorization = UserToken;
    const url = ApiUrl4 + 'config-waprofilepicture-get';
    
    var sender = senderid
    // if(sender == null || sender == "" || sender == undefined){
    //     sender = SenderId
    // }
    
    const argument = {  
        method: 'POST',
        headers : {
            'Authorization': Authorization,
            'senderid':sender
        },
    };  

    const response = await doFetch(url,argument);
    var data = fromJS({});
    if(response.ok){
        data = fromJS(await response.json());
        data = data.get('query-result')
        data = data.get('data').get('picture_url')
    }

    dispatch({ type: GetWaProfileImage, data: data });
    return response
};